<template>
  <div id="app">
    <router-view :key="$route.fullPath"  v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created(){
  },
  provide (){
    return {
      reload:this.reload
    }
  },
  data(){
    return {
      isRouterAlive:true
    }
  },
  methods:{
    reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  },
  components:{
  }

};
</script>
<style scoped>
.chinese {
  font-size: 22;
  color: #333;
}
.english {
  font-size: 22;
  color: #999;
}
</style>